export const parseDateOnly = (value) => {
  const [year, month, day] = String(value).split("-").map(Number);
  return new Date(year, month - 1, day);
};

export const formatDateOnly = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const monthKey = (year, month, language) => `${year}-${String(month).padStart(2, "0")}:${language}`;

export const shiftMonth = (year, month, amount) => {
  const next = new Date(year, month - 1 + amount, 1);
  return { year: next.getFullYear(), month: next.getMonth() + 1 };
};
